/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}


/**
 * 校验表达式
 * @type {{}}
 */
export const validExpr = {
  url: {
    expr: /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/,
    msg: {
      zh:'请输入正确的url格式',
      en:'Please enter the correct URL format'
    }
  },
  lowerCase: {
    expr:  /^[a-z]+$/,
    msg:{
      zh:'请输入正确的小写字母',
      en:'Please enter the correct lowercase letters'
    },
  },
  upperCase: {
    expr:  /^[A-Z]+$/,
    msg:{
      zh:'请输入正确的大写字母',
      en:'Please enter the correct capital letters'
    }
  },
  alphabets: {
    expr: /^[A-Za-z]+$/,
    msg: {
      zh:'请输入正确的字母',
      en:'Please enter the correct letter'
    },
  },
  email: {
    expr: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    msg: {
      zh:'请输入正确的邮箱格式',
      en:'Please enter the correct email format'
    }
  },
  oneDecimal: {
    expr: /(^[1-9]([0-9]+)?(\.[0-9]{1,1})?$)|(^(0){1}$)|(^[0]\.([0-9]{1,1})?$)/,
    msg:{
      zh:'请输入正确格式,可保留一位小数',
      en:'Formatting error and keeping at most one decimal place'
    }
  },
  twoDecimal: {
    expr: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0]\.([0-9]{1,2})?$)/,
    msg:{
      zh:'请输入正确格式,可保留两位小数',
      en:'Formatting error and keeping at most two decimal place'
    }
  },
  threeDecimal: {
    expr: /(^[1-9]([0-9]+)?(\.[0-9]{1,3})?$)|(^(0){1}$)|(^[0]\.([0-9]{1,3})?$)/,
    msg:{
      zh:'请输入正确格式,可保留三位小数',
      en:'Formatting error and keeping at most three decimal place'
    }
  },
  idCard: {
    expr: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
    msg: {
      zh:'请输入正确的身份证号格式'
    }
  },
  phone: {
    expr: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
    msg: {
      zh:'请输入正确的手机号码',
    }
  },
  integer: {
    expr: /^\d+$/,
    msg:{
      zh:'请输入正确整数格式',
      en:'Please enter a correct integer format'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/apply/util/validate.js